<template>
  <el-tooltip
    effect="dark"
    :content="active ? '退出全屏' : '全屏'"
    placement="bottom">
    <!-- 页签栏使用与关闭按钮相同的普通按钮，统一悬停和移出效果。 -->
    <el-button
      :class="tabControl ? 'd2-fullscreen-toggle' : 'd2-mr btn-text can-hover'"
      :type="tabControl ? 'default' : 'text'"
      :aria-label="active ? '退出全屏' : '全屏'"
      @click="toggle">
      <d2-icon v-if="active" name="compress"/>
      <d2-icon v-else name="arrows-alt" style="font-size: 16px"/>
    </el-button>
  </el-tooltip>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    // 同一布局切换入口分别用于顶栏和页签栏，避免两套恢复逻辑。
    tabControl: { type: Boolean, default: false }
  },
  computed: {
    ...mapState('d2admin/fullscreen', [
      'active'
    ])
  },
  methods: {
    ...mapActions('d2admin/fullscreen', [
      'toggle'
    ])
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-fullscreen/index.vue"
}
</vue-filename-injector>
